import { user_addresses } from "@core/gql-mockups/addresses";
import { minimize_str } from "@core/helpers/string";


export const CREATE_USER_ADDRESS = minimize_str(`
  mutation ($input: UserAddressInput) {
   result: createUserAddress(input: $input) ${user_addresses}
  }
`);

export const UPDATE_USER_ADDRESS = minimize_str(`
  mutation ($address_id: ID, $input: UserAddressInput){
   result: updateUserAddress(address_id: $address_id, input: $input) ${user_addresses}
  }
`);

export const DELETE_USER_ADDRESS = minimize_str(`
  mutation ($address_id: ID){
   result: deleteUserAddress(address_id: $address_id){
      success
      message
    }
  }
`);

export const SET_USER_DEFAULT_ADDRESS = minimize_str(`
  mutation ($address_id: ID) {
   result: setUserDefaultAddress(address_id: $address_id) {
      success
      message
    }
  }
`);

